import { useContext } from 'react';
import { collectionPageContext, entityPageContext } from '../providers';

export const usePageButtonBiParams = (): {
  pageType: 'Entity' | 'Collection' | undefined;
  location: 'Entity Page Header' | 'Collection Page Header' | undefined;
} => {
  const entityContext = useContext(entityPageContext);
  const collectionContext = useContext(collectionPageContext);

  if (entityContext) {
    return { pageType: 'Entity', location: 'Entity Page Header' };
  }

  if (collectionContext) {
    return { pageType: 'Collection', location: 'Collection Page Header' };
  }

  return { pageType: undefined, location: undefined };
};
